import { Button, IconButton, InputAdornment, Menu, MenuItem, TextField, Tooltip, Badge } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';

import DateField from '../../../components/UI/DateField';

const initFilter = {
  assetMin: '',
  assetMax: '',
  subscriptionMin: '',
  subscriptionMax: '',
  mutualBuddyMin: '',
  mutualBuddyMax: '',
  startDate: '',
  endDate: '',
  mutualRoomMin: '',
  mutualRoomMax: '',
  tier: '',
};

const FilterMenu = ({ onFilterReset, filterState, onFilterApply }) => {
  const login = useSelector((state) => state.login);
  const { registered } = login.user;
  const [filterStateLocal, setFilterStateLocal] = useState(initFilter);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (!registered) {
      Swal.fire('For added security, we kindly ask you to confirm your primary email before utilizing this feature.');
    } else {
      setFilterStateLocal(filterState);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setFilterStateLocal(initFilter);
  };

  const handleFilterApply = () => {
    onFilterApply(filterStateLocal);
    handleClose();
  };

  const isThisResetState =
    filterState?.assetMin !== '' ||
    filterState?.assetMax !== '' ||
    filterState?.subscriptionMin !== '' ||
    filterState?.subscriptionMax !== '' ||
    filterState?.mutualBuddyMin !== '' ||
    filterState?.mutualBuddyMax !== '' ||
    filterState?.tier !== '' ||
    filterState?.mutualRoomMax !== '' ||
    filterState?.mutualRoomMin !== '' ||
    filterState?.endDate !== '' ||
    filterState?.startDate !== '';

  const handleFilterReset = () => {
    isThisResetState && onFilterReset();
    setFilterStateLocal(initFilter);
    handleClose();
  };

  return (
    <div>
      <Tooltip title="Filter">
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            // ml: 2,
            backgroundColor: '#3D71FF',
            height: '40px',
            width: '40px',
            '&:hover': { backgroundColor: '#3D71FF' },
          }}
        >
          <Badge color="error" variant="dot" invisible={!isThisResetState}>
            <FilterAltIcon sx={{ color: 'white' }} />
          </Badge>
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          style: {
            width: '350px',
            padding: '0px 8px',
          },
        }}
      >
        <h2>Filter</h2>
        <TextField
          value={filterStateLocal?.tier}
          onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, tier: e.target.value }))}
          sx={{
            my: '8px',
          }}
          select
          label="User Tier"
          size="small"
          fullWidth
          variant="outlined"
        >
          <MenuItem value="0">Beta User</MenuItem>
          <MenuItem value="1">Free User</MenuItem>
          <MenuItem value="2">Basic User</MenuItem>
          <MenuItem value="3">Premium User</MenuItem>
        </TextField>
        {/* Mutual Asset */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '2px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Mutual Assets
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.assetMin}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, assetMin: e.target.value }))}
              label="Min"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.assetMax}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, assetMax: e.target.value }))}
              label="Max"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
          </div>
        </div>
        {/* Mutual subscription */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '2px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Mutual Subscriptions
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.subscriptionMin}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, subscriptionMin: e.target.value }))}
              label="Min"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.subscriptionMax}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, subscriptionMax: e.target.value }))}
              label="Max"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
          </div>
        </div>
        {/* Mutual Buddy */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '2px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Mutual Buddies
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.mutualBuddyMin}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, mutualBuddyMin: e.target.value }))}
              label="Min"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.mutualBuddyMax}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, mutualBuddyMax: e.target.value }))}
              label="Max"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
          </div>
        </div>
        {/* Mutual Room */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '2px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Mutual Rooms
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.mutualRoomMin}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, mutualRoomMin: e.target.value }))}
              label="Min"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
            <TextField
              style={{ marginBottom: '8px' }}
              value={filterStateLocal?.mutualRoomMax}
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, mutualRoomMax: e.target.value }))}
              label="Max"
              size="small"
              type="number"
              fullWidth
              variant="outlined"
            />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', margin: '2px 0px' }}>
          <span className="filter-sub-label-x2" style={{ paddingLeft: '6px' }}>
            Date
          </span>
          <div style={{ display: 'flex', gap: '8px' }}>
            <DateField
              value={filterStateLocal.startDate}
              fullWidth
              variant="outlined"
              label="From"
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, startDate: e.toISOString() }))}
            />
            <DateField
              value={filterStateLocal.endDate}
              fullWidth
              variant="outlined"
              label="To"
              onChange={(e) => setFilterStateLocal((prev) => ({ ...prev, endDate: e.toISOString() }))}
            />
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'end', gap: '8px' }}>
          <Button
            sx={{
              textTransform: 'capitalize',
              backgroundColor: '#ff4842',
              color: 'white',
              borderRadius: '30px',
              ':hover': { backgroundColor: '#d40700' },
            }}
            onClick={handleClose}
            size="small"
            variant="contained"
          >
            Close
          </Button>
          <Button
            sx={{ textTransform: 'capitalize', borderRadius: '30px' }}
            onClick={handleFilterReset}
            size="small"
            variant="contained"
          >
            Reset
          </Button>
          <Button
            sx={{ textTransform: 'capitalize', borderRadius: '30px' }}
            onClick={handleFilterApply}
            size="small"
            variant="contained"
          >
            Apply
          </Button>
        </div>
      </Menu>
    </div>
  );
};

export default FilterMenu;
